import { DEFAULT_TIMEZONE } from '../../constants/workTime';
import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectTimezone = (state: IApplicationState) => {
  const { timezone } = selectNewbuilding(state);

  return timezone ?? DEFAULT_TIMEZONE;
};
